import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-menu-skeleton',
  template: `
    <div class="mx-auto min-h-screen max-w-md bg-slate-50 px-6 py-8 text-slate-900">
      <div
        class="flex animate-pulse flex-col items-center gap-3"
        aria-busy="true"
        aria-live="polite"
      >
        <div class="h-24 w-24 rounded-2xl bg-slate-200"></div>
        <div class="h-6 w-1/2 rounded bg-slate-200"></div>
        <div class="h-3 w-1/3 rounded bg-slate-200"></div>
      </div>
      <div class="mt-8 flex animate-pulse gap-2 overflow-hidden">
        @for (i of tabPlaceholders; track i) {
          <div class="h-9 w-24 shrink-0 rounded-full bg-slate-200"></div>
        }
      </div>
      <div class="mt-8 grid animate-pulse gap-6">
        @for (i of cardPlaceholders; track i) {
          <div class="h-64 w-full rounded-3xl bg-slate-200"></div>
        }
      </div>
    </div>
  `,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSkeleton {
  protected readonly tabPlaceholders = [0, 1, 2, 3];
  protected readonly cardPlaceholders = [0, 1, 2];
}
